<div class="error-details-modal" [ngClass]="getSeverityClass()">
  <div class="modal-header">
    <div class="header-content">
      <mat-icon class="material-symbols-outlined severity-icon">{{ getSeverityIcon() }}</mat-icon>
      <div class="header-text">
        <h2 class="modal-title">Error Details</h2>
        <span class="card-info" *ngIf="data.cardTitle || data.cardId">
          {{ data.cardTitle || data.cardId }}
        </span>
      </div>
    </div>
    <button mat-icon-button class="close-button" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <!-- Error Message -->
    <div class="error-message-section">
      <p class="error-message">{{ data.error.message }}</p>
      <p class="suggested-action" *ngIf="data.error.suggestedAction">
        <mat-icon class="material-symbols-outlined">lightbulb</mat-icon>
        {{ data.error.suggestedAction }}
      </p>
    </div>

    <!-- Error Details Grid -->
    <div class="details-grid">
      <div class="detail-item">
        <span class="detail-label">Error Code</span>
        <span class="detail-value code">{{ data.error.code }}</span>
      </div>

      <div class="detail-item">
        <span class="detail-label">Severity</span>
        <span class="detail-value severity-badge" [ngClass]="getSeverityClass()">
          {{ data.error.severity }}
        </span>
      </div>

      <div class="detail-item">
        <span class="detail-label">Timestamp</span>
        <span class="detail-value">{{ data.error.timestamp | date:'medium' }}</span>
      </div>

      <div class="detail-item" *ngIf="data.error.recoverable !== undefined">
        <span class="detail-label">Recoverable</span>
        <span class="detail-value">{{ data.error.recoverable ? 'Yes' : 'No' }}</span>
      </div>
    </div>

    <!-- Request/Execution IDs -->
    <div class="ids-section" *ngIf="data.error.requestId || data.error.executionId">
      <h3 class="section-title">Tracking Information</h3>
      <div class="id-item" *ngIf="data.error.requestId">
        <span class="id-label">Request ID</span>
        <code class="id-value">{{ data.error.requestId }}</code>
      </div>
      <div class="id-item" *ngIf="data.error.executionId">
        <span class="id-label">Execution ID</span>
        <code class="id-value">{{ data.error.executionId }}</code>
      </div>
    </div>

    <!-- Technical Details -->
    <div class="technical-section" *ngIf="data.error.details">
      <h3 class="section-title">Technical Details</h3>
      <pre class="technical-details">{{ data.error.details }}</pre>
    </div>

    <!-- Context -->
    <div class="context-section" *ngIf="data.error.context">
      <h3 class="section-title">Context</h3>
      <pre class="context-json">{{ data.error.context | json }}</pre>
    </div>

    <!-- Stack Trace -->
    <div class="stack-section" *ngIf="data.error.stack">
      <h3 class="section-title">Stack Trace</h3>
      <pre class="stack-trace">{{ data.error.stack }}</pre>
    </div>
  </div>

  <div class="modal-footer">
    <button mat-button class="copy-button" (click)="copyToClipboard()">
      <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
      Copy to Clipboard
    </button>
    <button mat-flat-button color="primary" (click)="close()">
      Close
    </button>
  </div>
</div>
